/** When your routing table is too long, you can split it into small modules**/

let deRouters = [
    {
        title: '公用副程序管理',
        icon: { icon: 'tabler-box' },
        children: []
    }
]

const modulesFiles = import.meta.glob('./de/*.ts', { eager: true })

Object.keys(modulesFiles).forEach(key => {
const module = modulesFiles[key]
deRouters[0].children.push(module.default)
})

export default deRouters
